document.addEventListener('DOMContentLoaded', () => {
  const parameters = new URLSearchParams(window.location.search);
  if (parameters.get('contact_posted') !== 'true') return;

  const modal = document.querySelector('[data-contact-success-modal]');
  const dialog = modal?.querySelector('.contact-success-modal__dialog');
  const title = modal?.querySelector('[data-contact-success-title]');
  const message = modal?.querySelector('[data-contact-success-message]');
  if (!modal || !dialog || !title || !message) return;

  const submittedForm = window.location.hash.replace('#', '');
  if (submittedForm.startsWith('SourcingForm')) {
    title.textContent = 'Sourcing request submitted';
  } else if (submittedForm.startsWith('CustomRequest')) {
    title.textContent = 'Custom project submitted';
  } else if (submittedForm.startsWith('CaseRequestForm')) {
    title.textContent = 'Project request submitted';
  }
  message.textContent = 'Thank you for your trust. Your dedicated account manager will contact you within 24 hours.';

  const closeModal = () => {
    modal.hidden = true;
    document.body.classList.remove('has-contact-success-modal');
    parameters.delete('contact_posted');
    const query = parameters.toString();
    window.history.replaceState({}, '', `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`);
  };

  modal.hidden = false;
  document.body.classList.add('has-contact-success-modal');
  dialog.focus();
  modal.querySelectorAll('[data-contact-success-close]').forEach((button) => button.addEventListener('click', closeModal));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modal.hidden) closeModal();
  });
});
